import { Navigate } from "react-router-dom";

const RedirectIfLoggedIn = ({ children }) => {
    const user = localStorage.getItem("user");
    try {
        const userData = JSON.parse(user);
        if (userData) {
            return <Navigate to="/HomePage" />;
        }
    } catch (error) {
        console.error("Error parsing user data:", error);
    }
    return children;
};

export default RedirectIfLoggedIn;
